import React from 'react';
import { Box, Checkbox, Tooltip } from '@mui/material';
import DesktopWindowsIcon from '@mui/icons-material/DesktopWindows';
import PictureInPictureAltIcon from '@mui/icons-material/PictureInPictureAlt';
import { useTranslation } from 'react-i18next';
import usePractitionerControlsContext from '../../../hooks/usePractitionerControlsContext/usePractitionerControlsContext';
import { ViewSwapToggleStyle } from './style';

interface ViewSwapToggleProps {
  isCallActive: boolean;
  hasMedia: boolean;
}

const ViewSwapToggle: React.FC<ViewSwapToggleProps> = ({ isCallActive, hasMedia }) => {
  const { viewSwapped, setViewSwapped } = usePractitionerControlsContext();
  const { t } = useTranslation();

  if (!isCallActive && !hasMedia) {
    return null;
  }

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setViewSwapped(event.target.checked);
  };

  const tooltip = viewSwapped
    ? (t('view-swap-restore', { defaultValue: 'Restore default view' }) as string)
    : (t('view-swap-to-client-view', { defaultValue: 'Move to client view' }) as string);

  return (
    <Box sx={ViewSwapToggleStyle.wrapper}>
      <Tooltip title={tooltip} placement="top">
        <Checkbox
          checked={viewSwapped}
          onChange={handleChange}
          disableRipple
          icon={<DesktopWindowsIcon />}
          checkedIcon={<PictureInPictureAltIcon />}
          sx={ViewSwapToggleStyle.checkbox}
          inputProps={{ 'aria-label': tooltip }}
          data-testid="pwid-view-swap-toggle"
        />
      </Tooltip>
    </Box>
  );
};

export default ViewSwapToggle;
